<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" icon="plus" @click="addVisible = true">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiSysparmQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="系统参数查询">
				<div style="display: flex;justify-content: space-between;">
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 90px;">参数名称：</div>
						<a-input v-model="query.sysparmName" style="width: 100%;" placeholder="请输入系统参数名称" />
					</div>
				
					<div style="width: 30%;display: flex;align-items: center;justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiSysparmQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>首级</a-breadcrumb-item>
					<a-breadcrumb-item href="" v-for="(item,index) in mainNavigation" :key="index"><i :class="item.icon"></i>{{item.sysparmName}}</a-breadcrumb-item>
				</a-breadcrumb>
				<a-tooltip placement="bottomRight">
					<template slot="title">
					  <span>返回上一级</span>
					</template>
					<a-button type="link" @click="backMainNavigation"><i class="icon-sjp-fanhui"></i></a-button>
				</a-tooltip>
			</div>
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="sysparmId"
				:loading="tableLoading" :pagination="false">
				<span slot="sysparmName" slot-scope="sysparmName">
					<a-button type="link" @click="edit(sysparmName)" >{{sysparmName.sysparmName}}</a-button>
				</span>
				<span slot="icon" slot-scope="icon">
					<i :class="icon"></i>
				</span>
				<span slot="sysparmState" slot-scope="sysparmState">
					<span v-if="sysparmState == 2">禁用</span>
					<span v-if="sysparmState == 3">启用</span>
				</span>
				<span slot="tableAction" slot-scope="tableAction">
					<a-button type="link" @click="addMainNavigation(tableAction)" >子参数</a-button>
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->
		<a-modal title="添加" width="600px" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="addHandleCancel" :maskClosable="false" :keyboard="false">
			<a-form-model ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
				<a-form-model-item label="参数名称" has-feedback prop="sysparmName">
					<a-input v-model="addForm.sysparmName" />
				</a-form-model-item>
				<a-form-model-item label="参数a" has-feedback prop="valueA">
					<a-input v-model="addForm.valueA" />
				</a-form-model-item>
				<a-form-model-item label="参数b" has-feedback prop="valueB">
					<a-input v-model="addForm.valueB" />
				</a-form-model-item>
				<a-form-model-item label="参数c" has-feedback prop="valueC">
					<a-input v-model="addForm.valueC" />
				</a-form-model-item>
				<a-form-model-item label="参数d" has-feedback prop="valueD">
					<a-input v-model="addForm.valueD" />
				</a-form-model-item>
				<a-form-model-item label="参数e" has-feedback prop="valueE">
					<a-input v-model="addForm.valueE" />
				</a-form-model-item>
				<a-form-model-item label="备注" has-feedback prop="remarks">
					<a-textarea v-model="addForm.remarks" placeholder="请输入备注信息" :rows="4" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
		<!-- 修改弹窗 -->
		<a-modal title="修改" width="600px" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="editHandleCancel" :maskClosable="false" :keyboard="false">
			<a-form-model ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
				<a-form-model-item label="参数名称" has-feedback prop="sysparmName">
					<a-input v-model="editForm.sysparmName" />
				</a-form-model-item>
				<a-form-model-item label="参数a" has-feedback prop="valueA">
					<a-input v-model="editForm.valueA" />
				</a-form-model-item>
				<a-form-model-item label="参数b" has-feedback prop="valueB">
					<a-input v-model="editForm.valueB" />
				</a-form-model-item>
				<a-form-model-item label="参数c" has-feedback prop="valueC">
					<a-input v-model="editForm.valueC" />
				</a-form-model-item>
				<a-form-model-item label="参数d" has-feedback prop="valueD">
					<a-input v-model="editForm.valueD" />
				</a-form-model-item>
				<a-form-model-item label="参数e" has-feedback prop="valueE">
					<a-input v-model="editForm.valueE" />
				</a-form-model-item>
				<a-form-model-item label="备注" has-feedback prop="remarks">
					<a-textarea v-model="editForm.remarks" placeholder="请输入备注信息" :rows="4" />
				</a-form-model-item>
				
			</a-form-model>
		</a-modal>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					parentId: 0,
					sysparmName: '',
				},
				mainNavigation: [
					
				],
				tableData: [],
				tableColumns: [{
						title: '参数ID',
						dataIndex: 'sysparmId',
						key: 'sysparmId',
						align: 'center'
					},
					{
						title: '参数名称',
						key: 'sysparmName',
						align: 'center',
						scopedSlots: {
							customRender: 'sysparmName'
						}
					},
					{
						title: '参数a',
						dataIndex: 'valueA',
						key: 'valueA',
						align: 'center',
					},
					{
						title: '参数b',
						dataIndex: 'valueB',
						key: 'valueB',
						align: 'center'
					},
					{
						title: '参数c',
						dataIndex: 'valueC',
						key: 'valueC',
						align: 'center',
					},
					{
						title: '参数d',
						dataIndex: 'valueD',
						key: 'valueD',
						align: 'center',
					},
					{
						title: '参数e',
						dataIndex: 'valueE',
						key: 'valueE',
						align: 'center'
					},
					{
						title: '备注',
						dataIndex: 'remarks',
						key: 'remarks',
						align: 'center'
					},
					{
						title: '状态',
						dataIndex: 'sysparmState',
						key: 'sysparmState',
						align: 'center',
						scopedSlots: {
							customRender: 'sysparmState'
						}
					},
					{
						title: '操作',
						key: 'tableAction',
						align: 'center',
						scopedSlots: {
							customRender: 'tableAction'
						}
					},

				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					sysparmName: '',
					valueA: '',
					valueB: '',
					valueC: '',
					valueD: '',
					valueE: '',
					parentId: 0,
					remarks: ''
				},
				addRules: {
					sysparmName: [{ required: true, message: '参数名称不能为空', trigger: 'blur' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					sysparmName: '',
					valueA: '',
					valueB: '',
					valueC: '',
					valueD: '',
					valueE: '',
					parentId: 0,
					remarks: ''
				},
				// 修改弹窗-end
			};
		},
		methods: {
			//表格面包屑-开始
			addMainNavigation(item) {
				this.mainNavigation.push(item)
				this.query.parentId = item.sysparmId
				this.apiSysparmQueryList()
				
			},
			backMainNavigation() {
				this.mainNavigation.pop()
				let i = this.mainNavigation.length
				if (i == 0) {
					this.query.parentId = 0
				} else {
					i = i -1
					this.query.parentId = this.mainNavigation[i].sysparmId
				}
				this.apiSysparmQueryList()
				
			},
			//表格面包屑-结束
			async apiSysparmQueryList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiSysparmQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiSysparmQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiSysparmQueryList()
			},
			//添加弹窗事件-开始
			async apiSysparmAdd() {
				this.addForm.parentId = this.query.parentId
				const {
					data: res
				} = await this.$http.post(this.navigation.apiSysparmAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiSysparmQueryList()
					this.addConfirmLoading = false
					this.addVisible = false
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiSysparmAdd()
					} else {
					  return false;
					  this.addConfirmLoading = true
					}
				});
				
			},
			addHandleCancel() {
				this.addVisible = false
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			edit(item){
				this.editForm = item
				this.editVisible = true
			},
			async apiSysparmEdit() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiSysparmEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.editRuleForm.resetFields();
					this.apiSysparmQueryList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiSysparmEdit()
					} else {
					  return false;
					  this.editConfirmLoading = true
					}
				});
				
			},
			editHandleCancel() {
				this.editVisible = false
			},
			//修改弹窗事件-结束
			
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.sysparmId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: this.tableSelectedRows.sysparmName,
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiSysparmDel()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiSysparmDel() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiSysparmDel, {sysparmId: this.tableSelectedRows.sysparmId});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiSysparmQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			tableEdit() {
				if(this.tableSelectedRows.sysparmId > 0) {
					this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			}
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'radio',
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0];
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiSysparmQueryList()
		}
	};
</script>

<style scoped>

</style>
